module.exports = __webpack_public_path__ + "img/News_item_6.1b7c395f.jpg";